/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const UploadCloudFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M7 20.98a6.5 6.5 0 0 1-2.94-12 8 8 0 0 1 15.88 0 6.5 6.5 0 0 1-2.94 12V21H7zM13 13h3l-4-5-4 5h3v4h2z" />
  </Icon>
);
